import { format, formatDistanceToNow, parseISO, isToday, isYesterday } from 'date-fns';
import { he } from 'date-fns/locale';

export function formatDate(isoDate: string, pattern = 'dd/MM/yyyy'): string {
  try {
    return format(parseISO(isoDate), pattern, { locale: he });
  } catch {
    return isoDate;
  }
}

export function formatDateTime(isoDate: string): string {
  return formatDate(isoDate, 'dd/MM/yyyy HH:mm');
}

export function formatRelative(isoDate: string): string {
  try {
    const date = parseISO(isoDate);
    if (isToday(date)) return formatDistanceToNow(date, { addSuffix: true, locale: he });
    if (isYesterday(date)) return `אתמול ${format(date, 'HH:mm')}`;
    return formatDate(isoDate);
  } catch {
    return isoDate;
  }
}

export function formatSmart(isoDate: string): string {
  try {
    const date = parseISO(isoDate);
    const diffDays = Math.floor((Date.now() - date.getTime()) / 86400000);
    return diffDays < 7 ? formatRelative(isoDate) : formatDate(isoDate);
  } catch {
    return isoDate;
  }
}
